/* eslint-disable */
import axios from 'axios'

const bookingService = {
    sendToGAT(sid){
        return new Promise(resolve=>{
            axios.post(
                '/api/Go/SendToGAT',
                "sid=" + sid
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },    
    getPaymentStatus(sid){
        return new Promise(resolve=>{
            axios.post(
                '/api/BookingInformation/GetPaymentStatus',
                "searchId=" + sid
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
    getFlightBagInfo(sid){
        return new Promise(resolve=>{
            axios.post(
                '/api/GO/GetFlightBagInfo',
                "sid=" + sid
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
    sendInitialRequest(data){
        return new Promise(resolve=>{
            axios.post(
                '/api/GO/BookingInformation_Responsive',
                "id=" + data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
    getBookingInformation(data){
        return new Promise(resolve=>{
            axios.post(
                '/api/BookingInformation/GetInfo_Responsive',
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
    getGmcForm(sid,paymentCode,merchantCode){
        return new Promise(resolve=>{
            axios.post(
                '/api/Flight2C_3/GetGMCPaymentInfo',
                'searchId='+ sid
                + "&paymentCode=" + encodeURIComponent(paymentCode)
                + "&merchantCode=" + encodeURIComponent(merchantCode)
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
    getSearchIdFromCookie(){
        return new Promise(resolve=>{
            axios.post(
                '/api/GO/GetSearchIdFromCookie',
                {}
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });        
    },
    changeBookingPaymentMethod (sid, paymentCode, merchantCode) {
      return new Promise(resolve => {
        axios.post(
          '/api/BookingInformation/ChangePaymentMethod',
          'searchId='+ sid
          + "&paymentType=" + encodeURIComponent(paymentCode)
          + "&merchant=" + encodeURIComponent(merchantCode)
        ).then (result => {
          resolve(result.data)
        }).catch (err=>{
          resolve({error: err})
        })
      })
    }
}

export default bookingService;